import React, { useEffect, useMemo, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import { getAllPeriodLock } from "../../../Redux/action/MasterAction";
import { getCompanyDetails } from "../../../Redux/action/NavbarAction";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";

const columns = [
  {
    title: "Period",
    dataIndex: "financial_year",
    key: "financial_year",
  },
  {
    title: "Locked By",
    dataIndex: "locked_by",
    key: "locked_by",
  },
  {
    title: "Lock Date",
    dataIndex: "lock_date",
    key: "lock_date",
  },
  {
    title: "Lock Level",
    dataIndex: "lock_level",
    key: "lock_level",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Actions",
    dataIndex: "action",
    key: "action",
    render: (text) => <button className="btn btn-link p-0">{text}</button>,
  },
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const AccountingPeriodLock = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const {
    loadingPeriodLock,
    PeriodLock,
    PeriodLockError,
    PeriodLockCurrentPage,
    PeriodLockTotalPage,
    PeriodLockTotalData,

    ProfileData,
  } = useSelector((state) => state?.MasterReducer);

  const { loadingCompanyDetail, CompanyDetailData, CompanyDetailDataError } =
    useSelector((state) => state?.NavbarReducer);

  const [periodLock, setPeriodLock] = useState({
    financial_year: "",
    period_month: "",
    lock_date: "",
    lock_level: "",
    allow_super_user_edit: false,
    send_notification: false,
    lock_reason: "",
  });

  const [dataSourcer, setDataSourcer] = useState([
    {
      key: 1,
      period: "December 2024",
      locked_by: "Admin User",
      lock_date: "2025-01-05",
      lock_level: "Hard",
      status: "Locked",
    },
    {
      key: 2,
      period: "November 2024",
      locked_by: "Admin User",
      lock_date: "2024-12-05",
      lock_level: "Soft",
      status: "Unlock",
    },
  ]);

  const [editshow, setEditShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const refresh = () => {
    if (token && user_id) {
      dispatch(
        getAllPeriodLock(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search"),
        ),
      );
    }
  };

  const statusChange = async (id) => {
    // setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/period-lock-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        // setSpinnerLoader(false);
        toast.success(data?.msg);
        refresh();
      } else {
        // setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      // setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    statusChange(id);
  };

  const handleEditShow = (id) => {
    if (id) {
      setEditShow(true);
    } else {
      toast.error("Id not found. Please retry.");
    }
  };

  const dataSource = PeriodLock?.map((value, i) => ({
    key: i,
    SNo: i + 1,
    financial_year: value?.financial_year,
    locked_by: value?.locked_by,
    lock_date: value?.lock_date.split("T")[0],
    lock_level: value?.lock_level,
    status: (
      <>
        <span
          id={`flexSwitchCheckChecked-${i}`}
          title="Click to change status"
          onClick={() => handleChange(value.id)}
          className={`cursor-pointer ${
            value.status === "Unlock"
              ? "badge badge-pill badge-status bg-success"
              : "badge badge-pill badge-status bg-danger"
          }  `}
        >
          {value.status === "Unlock" ? "Unlock" : "Locked"}
        </span>
      </>
    ),
    action: (
      <div className="dropdown table-action">
        <Link to="#" className="action-icon" data-bs-toggle="dropdown">
          <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
          <div
            className=" cursor-pointer"
            onClick={() => {
              handleEditShow(value?.id);
            }}
          >
            <i className="ti ti-edit text-blue"></i> View
          </div>
        </div>
      </div>
    ),
  }));

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setPeriodLock((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validation = () => {
    let error = [];

    if (!periodLock.financial_year) {
      error.push("financial year is required");
    }

    if (!periodLock.lock_date) {
      error.push("lock date is required");
    }

    if (!periodLock.lock_level) {
      error.push("lock level is required");
    }

    if (!periodLock.period_month) {
      error.push("period month is required");
    }
    if (!periodLock.lock_reason) {
      error.push("lock reason is required");
    }

    if (error.length > 0) {
      error.forEach((item) => {
        toast.error(item);
      });
      return false;
    }

    return true;
  };

  const {
    financial_year,
    period_month,
    lock_date,
    lock_level,
    allow_super_user_edit,
    send_notification,
    lock_reason,
  } = periodLock;
  
  const createPeriodLock = async (status) => {
    if (!validation()) return;

    if (!CompanyDetailData?.company_name)
      return toast.error("Something went wrong while saving CompanyDetailData");

    try {
      setIsSubmitting(true);

      const response = await fetch(`${adminMainUrl}/api/account/period-lock`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": Cookies.get("token"),
          user_id: Cookies.get("flexichain_user_id"),
        },
        body: JSON.stringify({
          financial_year,
          period_month,
          lock_date,
          lock_time: new Date().toISOString(),
          allow_super_user_edit,
          send_notification,
          lock_reason,
          locked_by: CompanyDetailData?.company_name,
          lock_level,
          status,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        refresh();
        toast.success(data?.msg || "Period Lock created successfully");
      } else {
        toast.error(data?.msg || "Failed to create Period Lock");
        console.error("Server error:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Something went wrong while saving Period Lock");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (token && user_id) {
      dispatch(getCompanyDetails());

      dispatch(
        getAllPeriodLock(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search"),
        ),
      );
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);

  const getFinancialYear = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-based

    // April (3) to December (11)
    if (month >= 3) {
      return `${year}-${year + 1}`;
    } else {
      // January to March
      return `${year - 1}-${year}`;
    }
  };

  const currentPeriod = useMemo(() => {
    if (!PeriodLock?.length) return null;

    const today = new Date();
    const currentMonthName = months[today.getMonth()];
    const currentFY = getFinancialYear(today);

    const period = PeriodLock.find(
      (item) =>
        item.period_month === currentMonthName &&
        item.financial_year === currentFY,
    );

    return period || null;
  }, [PeriodLock]);

  return (
    <>
      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Accounting Period Lock</h5>
        <div className="row">
          {/* financial_year */}
          <div className="col-12 col-md-6 mb-4">
            <label className="form-label fw-medium">Financial Year</label>
            <select
              name="financial_year"
              className="form-select bg-light padding-pt-9"
              value={periodLock.financial_year}
              onChange={onValueChange}
            >
              <option value="">Select financial year name </option>
              <option value="2025-2026">2025-2026</option>
              <option value="2026-2027">2026-2027</option>
              <option value="2027-2028">2027-2028</option>
              <option value="2028-2029">2028-2029</option>
              <option value="2029-2030">2029-2030</option>
              <option value="2030-2031">2030-2031</option>
              <option value="2031-2032">2031-2032</option>
              <option value="2032-2033">2032-2033</option>
              <option value="2033-2034">2033-2034</option>
              <option value="2034-2035">2034-2035</option>
            </select>
          </div>

          {/* period_month */}
          <div className="col-12 col-md-6 mb-4">
            <label className="form-label fw-medium">Period Month</label>
            <select
              name="period_month"
              className="form-select bg-light padding-pt-9"
              value={periodLock.period_month}
              onChange={onValueChange}
            >
              <option value="">Select Period Month Name </option>
              {months.map((item, i) => (
                <option key={i} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          {/* lock_date */}
          <div className="col-12 col-md-6 mb-4">
            <label className="form-label fw-medium">Lock Date</label>
            <input
              type="date"
              name="lock_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={periodLock.lock_date}
            />
          </div>

          {/* lock_level */}
          <div className="col-12 col-md-6 mb-4">
            <label className="form-label fw-medium">Lock Level </label>
            <select
              name="lock_level"
              className="form-select bg-light padding-pt-9"
              value={periodLock.lock_level}
              onChange={onValueChange}
            >
              <option value="">Select Lock Level Name </option>
              <option value="Soft">Soft</option>
              <option value="Hard">Hard </option>
            </select>
          </div>

          {/* allow_super_user_edit */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Allow Super User Edit
            </label>
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                  name="allow_super_user_edit"
                  checked={periodLock.allow_super_user_edit}
                  onChange={onValueChange}
                />
              </div>
              <span>{periodLock.allow_super_user_edit ? "Yes" : "No"}</span>
            </div>
          </div>

          {/* send_notification */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">Send Notification</label>
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                  name="send_notification"
                  checked={periodLock.send_notification}
                  onChange={onValueChange}
                />
              </div>
              <span>{periodLock.send_notification ? "Yes" : "No"}</span>
            </div>
          </div>

          {/* lock_reason */}
          <div className="col-12 mb-4">
            <label className="form-label fw-medium">Lock Reason</label>
            <input
              type="text"
              name="lock_reason"
              className="form-control bg-light"
              value={periodLock.lock_reason}
              onChange={onValueChange}
              placeholder="lock reason"
            />
          </div>

          <div className="card p-2">
            <h5>Warning: Locking a period will prevent modifications</h5>
            <p>
              Hard lock prevents all users from posting or modifying
              transactions in the locked period. Soft lock allows edits with
              warnings. Only proceed after completing all month-end tasks.
            </p>
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => createPeriodLock("Locked")}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-lock me-1"></i> Lock Period
            </button>

            <button
              onClick={() => createPeriodLock("Unlocked")}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-Unlock me-1"></i> Unlock
            </button>
            <button className="btn btn-light border px-4">
              <i className="fas fa-Preview me-1"></i> View History
            </button>

            <button className="btn btn-light border px-4">
              Send Notification
            </button>
          </div>
        </div>
      </div>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Current Period Status</h5>

        <div className="row g-3">
          {/* Current Period */}
          <div className="col-md-4">
            <div className="p-3 rounded-3 bg-light">
              <p className="text-muted mb-1 small">Current Period</p>
              <h6 className="mb-0">
                {currentPeriod?.period_month} {currentPeriod?.financial_year}
              </h6>
            </div>
          </div>

          {/* Status */}
          <div className="col-md-4">
            <div
              className="p-3 rounded-3"
              style={{ backgroundColor: "#f0fff4" }}
            >
              <p className="text-muted mb-1 small">Status</p>

              {/* Green Badge */}
              <span
                className={`badge ${
                  currentPeriod?.status == "Unlock" ? "bg-success" : "bg-danger"
                } `}
              >
                {currentPeriod?.status}
              </span>
            </div>
          </div>

          {/* Lock Level */}
          <div className="col-md-4">
            <div
              className="p-3 rounded-3"
              style={{ backgroundColor: "#eef5ff" }}
            >
              <p className="text-muted mb-1 small">Lock Level</p>
              <h6 className="mb-0">{currentPeriod?.lock_level}</h6>
            </div>
          </div>
        </div>
      </div>

      {/* table */}
      <div className="table-responsive custom-table">
        <Table
          className="table datanew dataTable no-footer"
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </div>

      <AccountPagination
        currentPage={PeriodLockCurrentPage}
        totalPages={PeriodLockTotalPage}
        onPageChange={(page) => {
           dispatch(getAllPeriodLock(token, user_id, page));
        }}
      />
      {/* <div className="card p-4 table-responsive custom-table query-list-table mt-4">
      </div> */}
    </>
  );
};

export default AccountingPeriodLock;
